<ng-container *ngIf="loaded; else showLoadingSpinner">
  <router-outlet />
</ng-container>

<ng-template #showLoadingSpinner>
  <div class="flex h-screen w-screen items-center justify-center">
    <app-loading size="w-40 h-40" />
  </div>
</ng-template>
